import { SectionHeading } from './SectionHeading'

// "How Jnati Works" — 3 cards (Sign Up → Connect → Grow) with gold
// arrows between them on desktop, gold downward arrows when stacked
// on mobile (#7r2). No step numbers — marketing's arrows convey
// sequence. Copy verbatim.

const STEPS: Array<{ title: string; body: string }> = [
  { title: 'Sign Up',  body: 'Join with phone or Google. Start instantly.' },
  { title: 'Connect',  body: 'Send/accept relation requests.' },
  { title: 'Grow',     body: 'Explore & expand your digital family.' },
]

export function HowItWorksSection() {
  return (
    <section className="py-12 sm:py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <SectionHeading>How Jnati Works</SectionHeading>
        <div className="mt-10 flex flex-col md:flex-row items-stretch justify-center gap-4 md:gap-2">
          {STEPS.map((s, idx) => (
            <div key={s.title} className="flex flex-col md:flex-row items-center md:items-stretch">
              <div className="bg-navy text-white rounded-xl p-6 text-center w-full md:w-[220px] min-h-[120px] flex flex-col justify-center shadow-[0_4px_12px_rgba(0,0,0,0.4)] border border-white/5">
                <h3 className="text-gold text-lg font-bold mb-1.5">{s.title}</h3>
                <p className="text-white/90 text-sm">{s.body}</p>
              </div>
              {idx < STEPS.length - 1 && (
                <div className="text-gold text-2xl md:text-3xl flex items-center justify-center my-2 md:my-0 md:mx-3" aria-hidden="true">
                  <span className="md:hidden">⬇</span>
                  <span className="hidden md:inline">▶</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
